if (!customElements.get('mosaic-component')) {
  customElements.define(
    'mosaic-component',
    class Mosaic extends HTMLElement {
      constructor() {
        super();

        this.onResizeCallback = () => this.onResize();
      }

      connectedCallback() {
        this.hasSliderMobile = this.hasAttribute('data-slider-mobile');
        this.carouselMobile = this.querySelector('.carousel--mobile');
        this.items = this.querySelectorAll('[data-item]');

        this.updateAOSAnchors();
        document.addEventListener('theme:resize:width', this.onResizeCallback);
      }

      onResize() {
        this.updateAOSAnchors();
      }

      updateAOSAnchors() {
        if (!theme.settings.animationsEnabled) return;

        // Animate all anchors at once when there is a carousel with native scrolling on mobile
        if (window.theme.isMobile() && this.hasSliderMobile && this.carouselMobile && this.items.length > 1) {
          const firstItem = this.items[0];
          const firstContentInner = firstItem.querySelector('[data-item-content-inner]');
          const blockId = firstItem.id;
          const contentInnerId = firstContentInner ? firstContentInner.id : blockId;

          firstItem.setAttribute('data-aos-trigger', `#${blockId}`);
          firstContentInner?.setAttribute('data-aos-trigger', `#${contentInnerId}`);

          this.items.forEach((item) => {
            const animatable = item.querySelectorAll('[data-aos], [data-aos-anchor]');
            const itemContentInner = item.querySelector('[data-item-content-inner]');

            item.setAttribute('data-aos-anchor', `#${blockId}`);
            itemContentInner?.setAttribute('data-aos-anchor', `#${contentInnerId}`);
            animatable.forEach((element) => element.setAttribute('data-aos-anchor', `#${contentInnerId}`));
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('theme:resize:width', this.onResizeCallback);
      }
    }
  );
}
